import * as actionTypes from "../../constants/actionTypes";
import * as handlers from "../../constants/handlers";
import * as itemTypes from "../../constants/itemTypes";
import * as methods from "../../constants/methods";
import * as formatHelper from "../../helpers/formatHelper";
import * as messageHelper from "../../helpers/messageHelper";
import * as responseHelper from "../../helpers/responseHelper";
import * as resultCodes from "../../constants/resultCodes";
import * as windowService from "../windowService";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.GET_FORMULA_NOTE_IMAGE:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            if (
                response.data === undefined ||
                response.data.id === undefined ||
                response.data.mimeType === undefined ||
                response.data.data === undefined
            ) {
                return [];
            }

            window.imageStore.addFormulaNoteImage(response.data.id, {
                type: response.data.mimeType,
                img: response.data.data
            });

            return [
                {
                    type: actionTypes.IMAGE_STORE_UPDATE
                }
            ];
        case handlers.GET_COLORANT_PACKAGE_IMAGE:
            if (!responseHelper.isImageFormatValid(response)) {
                window.imageStore.setColorantPackage(null);

                if (response.result !== resultCodes.RESULT_OK) {
                    return [
                        messageHelper.getFlashMessage(response),
                        {
                            type: actionTypes.IMAGE_STORE_UPDATE
                        }
                    ];
                }

                return [
                    {
                        type: actionTypes.IMAGE_STORE_UPDATE
                    }
                ];
            }

            window.imageStore.setColorantPackage({
                type: response.data.mimeType,
                img: response.data.data
            });

            return [
                {
                    type: actionTypes.IMAGE_STORE_UPDATE
                }
            ];
        case handlers.GET_DATABASE_IMAGE:
            if (!responseHelper.isGetDatabaseImageFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            if (response.data === undefined) {
                return [];
            }

            if (
                response.data === null ||
                response.data.database === undefined ||
                response.data.data === undefined ||
                response.data.mimeType === undefined
            ) {
                return [];
            }

            window.imageStore.addDbImage(response.data.database, {
                type: response.data.mimeType,
                img: response.data.data
            });

            return [
                {
                    type: actionTypes.IMAGE_STORE_UPDATE
                }
            ];
        case handlers.GET_COLOR_IMAGE:
            if (!responseHelper.isImageFormatValid(response)) {
                if (response.result !== resultCodes.RESULT_OK) {
                    return [messageHelper.getFlashMessage(response)];
                }

                return [];
            }

            let colorImageRequest = state.server.requests.find((request) => request.id === response.sequence);

            if (colorImageRequest === undefined) {
                return [];
            }

            window.imageStore.addCifImage(
                colorImageRequest.next.fandeckId,
                colorImageRequest.next.colorId,
                response.data.imageId,
                {type: response.data.mimeType, img: response.data.data}
            );

            return [
                {
                    type: actionTypes.IMAGE_STORE_UPDATE
                }
            ];
        case handlers.GET_PRODUCT_IMAGE:
            if (!responseHelper.isImageFormatValid(response)) {
                let warningRequests = [];

                if (response.result !== resultCodes.RESULT_OK) {
                    warningRequests.push(messageHelper.getFlashMessage(response));
                }

                warningRequests.push({
                    type: actionTypes.MAIN_TAB_SAVE_PACKAGE_IMAGE,
                    payload: {
                        tabId: tabId,
                        imageId: -1
                    }
                });

                let productImageRequest = state.server.requests.find((request) => request.id === response.sequence);

                if (productImageRequest?.next) {
                    warningRequests.push(productImageRequest.next);
                }

                return warningRequests;
            }

            window.imageStore.addImage(response.data.imageId, {type: response.data.mimeType, img: response.data.data});

            let requests = [
                {
                    type: actionTypes.MAIN_TAB_SAVE_PACKAGE_IMAGE,
                    payload: {
                        tabId: tabId,
                        imageId: response.data.imageId
                    }
                },
                {
                    type: actionTypes.IMAGE_STORE_UPDATE
                }
            ];

            let getProductImageRequest = state.server.requests.find((request) => request.id === response.sequence);

            if (getProductImageRequest?.next) {
                requests.push(getProductImageRequest.next);
            }

            return requests;
        case handlers.GET_DISPENSING_PRODUCT_IMAGE:
            if (!responseHelper.isImageFormatValid(response)) {
                if (response.result !== resultCodes.RESULT_OK) {
                    return [
                        messageHelper.getFlashMessage(response),
                        {
                            type: actionTypes.SAVE_DISPENSING_PACKAGE_IMAGE,
                            payload: {
                                imageId: -1
                            }
                        }
                    ];
                }

                return [
                    {
                        type: actionTypes.SAVE_DISPENSING_PACKAGE_IMAGE,
                        payload: {
                            imageId: -1
                        }
                    }
                ];
            }

            window.imageStore.addImage(response.data.imageId, {type: response.data.mimeType, img: response.data.data});

            return [
                {
                    type: actionTypes.SAVE_DISPENSING_PACKAGE_IMAGE,
                    payload: {
                        imageId: response.data.imageId
                    }
                },
                {
                    type: actionTypes.IMAGE_STORE_UPDATE
                }
            ];
        case handlers.INTERGAMMA_MACHINE_GET_PRODUCT_IMAGE:
        case handlers.GET_LIGHT_TO_DISPENSE_PRODUCT_IMAGE:
            if (!responseHelper.isImageFormatValid(response)) {
                if (response.result !== resultCodes.RESULT_OK) {
                    return [
                        messageHelper.getFlashMessage(response),
                        {
                            type: actionTypes.TO_DISPENSE_SAVE_PACKAGE_PREVIEW_IMAGE,
                            payload: {
                                imageId: -1
                            }
                        }
                    ];
                }

                return [
                    {
                        type: actionTypes.TO_DISPENSE_SAVE_PACKAGE_PREVIEW_IMAGE,
                        payload: {
                            imageId: -1
                        }
                    }
                ];
            }

            window.imageStore.addImage(response.data.imageId, {type: response.data.mimeType, img: response.data.data});

            return [
                {
                    type: actionTypes.TO_DISPENSE_SAVE_PACKAGE_PREVIEW_IMAGE,
                    payload: {
                        imageId: response.data.imageId
                    }
                },
                {
                    type: actionTypes.IMAGE_STORE_UPDATE
                }
            ];
        case handlers.GET_LIGHT_MY_ORDERS_PRODUCT_IMAGE:
            if (!responseHelper.isImageFormatValid(response)) {
                if (response.result !== resultCodes.RESULT_OK) {
                    return [
                        messageHelper.getFlashMessage(response),
                        {
                            type: actionTypes.MY_ORDERS_SAVE_PACKAGE_PREVIEW_IMAGE,
                            payload: {
                                imageId: -1
                            }
                        }
                    ];
                }

                return [
                    {
                        type: actionTypes.MY_ORDERS_SAVE_PACKAGE_PREVIEW_IMAGE,
                        payload: {
                            imageId: -1
                        }
                    }
                ];
            }

            window.imageStore.addImage(response.data.imageId, {type: response.data.mimeType, img: response.data.data});

            return [
                {
                    type: actionTypes.MY_ORDERS_SAVE_PACKAGE_PREVIEW_IMAGE,
                    payload: {
                        imageId: response.data.imageId
                    }
                },
                {
                    type: actionTypes.IMAGE_STORE_UPDATE
                }
            ];
        case handlers.GET_ALL_BANNERS:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            if (response.data.length === 0) {
                window.imageStore.setBannerList(windowService.getBannerImageList());

                return [
                    {
                        type: actionTypes.IMAGE_STORE_UPDATE
                    }
                ];
            }

            let bannerList = [];

            let banner;
            for (banner of response.data) {
                bannerList.push({
                    id: banner.id,
                    initialized: false
                });
            }

            window.imageStore.setBannerList([]);
            window.imageStore.setTempBannerList(bannerList);

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_BANNER_IMAGE,
                        params: {
                            bannerId: bannerList[0].id
                        }
                    },
                    method: handlers.GET_BANNER_IMAGE,
                    tabId: 0
                }
            ];
        case handlers.GET_BANNER_IMAGE:
            if (!responseHelper.isGetFileFormatValid(response)) {
                return [messageHelper.getFlashMessage(response)];
            }

            window.imageStore.addBannerImage({
                type: response.data.mimeType,
                img: response.data.data
            });

            let tempBanner;
            for (tempBanner of window.imageStore.getTempBannerList()) {
                if (tempBanner.id === response.data.id) {
                    tempBanner.initialized = true;
                }

                if (!tempBanner.initialized) {
                    return [
                        {
                            type: actionTypes.SERVER_REQUEST,
                            payload: {
                                type: methods.METHOD_GET_BANNER_IMAGE,
                                params: {
                                    bannerId: tempBanner.id
                                }
                            },
                            method: handlers.GET_BANNER_IMAGE,
                            tabId: 0
                        }
                    ];
                }
            }

            window.imageStore.setTempBannerList([]);

            return [
                {
                    type: actionTypes.IMAGE_STORE_UPDATE
                }
            ];
        case handlers.GET_BARCODE_TEST_MODAL_PRODUCT_IMAGE:
            if (!responseHelper.isImageFormatValid(response)) {
                if (response.result !== resultCodes.RESULT_OK) {
                    return [messageHelper.getFlashMessage(response)];
                }

                return [
                    {
                        type: actionTypes.IMAGE_STORE_UPDATE
                    }
                ];
            }

            window.imageStore.addBarcodeTestImage(itemTypes.BASE_IN_PRODUCT_PACKAGE, {
                type: response.data.mimeType,
                img: response.data.data
            });

            return [
                {
                    type: actionTypes.IMAGE_STORE_UPDATE
                }
            ];
        case handlers.GET_BARCODE_TEST_MODAL_COLORANT_PACKAGE_IMAGE:
            if (!responseHelper.isImageFormatValid(response)) {
                if (response.result !== resultCodes.RESULT_OK) {
                    return [messageHelper.getFlashMessage(response)];
                }

                return [
                    {
                        type: actionTypes.IMAGE_STORE_UPDATE
                    }
                ];
            }

            window.imageStore.addBarcodeTestImage(itemTypes.COLORANT_PACKAGE, {
                type: response.data.mimeType,
                img: response.data.data
            });

            return [
                {
                    type: actionTypes.IMAGE_STORE_UPDATE
                }
            ];
        case handlers.INIT_FILE_PREVIEW:
            if (response.result !== resultCodes.RESULT_OK) {
                return [
                    messageHelper.getInvalidFormatMessage(response),
                    {
                        type: actionTypes.IMAGE_STORE_UPDATE
                    }
                ];
            }

            let initFilePreviewRequest = state.server.requests.find((request) => request.id === response.sequence);
            let isOnlineFile = initFilePreviewRequest === undefined ? false : initFilePreviewRequest.next === true;

            if (!responseHelper.isGetFileInfoValid(response)) {
                if (!isOnlineFile) {
                    return [
                        messageHelper.getWarningMessageAction("flashMessage.productFileWarning"),
                        {
                            type: actionTypes.IMAGE_STORE_UPDATE
                        }
                    ];
                }

                return [
                    messageHelper.getInvalidFormatMessage(response),
                    {
                        type: actionTypes.IMAGE_STORE_UPDATE
                    }
                ];
            }

            return [
                {
                    type: isOnlineFile
                        ? actionTypes.UPDATE_PRODUCT_FILE_PAGES_ONLINE
                        : actionTypes.UPDATE_PRODUCT_FILE_PAGES,
                    payload: {
                        tabId: tabId,
                        fileId: response.data.id,
                        numberOfPages: response.data.numPages
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_FILE_PAGE_PREVIEW,
                        params: {
                            fileId: response.data.id,
                            page: 1,
                            online: isOnlineFile
                        }
                    },
                    method: handlers.GET_FILE_PAGE_PREVIEW,
                    tabId: tabId,
                    next: isOnlineFile
                }
            ];
        case handlers.GET_FILE_PAGE_PREVIEW:
            if (!responseHelper.isGetFilePreviewFormatValid(response)) {
                return [
                    messageHelper.getInvalidFormatMessage(response),
                    {
                        type: actionTypes.IMAGE_STORE_UPDATE
                    }
                ];
            }

            let filePreviewRequest = state.server.requests.find((request) => request.id === response.sequence);

            window.imageStore.addProductFileImage(
                response.data.fileId,
                response.data.page,
                filePreviewRequest.next === true,
                {
                    type: response.data.mimeType,
                    img: response.data.data
                }
            );

            return [
                {
                    type: actionTypes.IMAGE_STORE_UPDATE
                }
            ];
        case handlers.GET_FILE_AND_EXPORT:
            if (!responseHelper.isGetFileFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            let getFileRequest = state.server.requests.find((request) => request.id === response.sequence);

            if (getFileRequest.next === null) {
                windowService.openSaveDialog(response.data.data, formatHelper.formatFileName("PDF", "pdf"));
            } else {
                windowService.openSaveDialog(response.data.data, getFileRequest.next);
            }

            return [];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
